import Router from 'vue-router'
import Login from '../components/Login'
import OrderList from '../components/OrderList'
import Pay from '../components/Pay'

import Vue from 'vue'
Vue.use(Router)
export default new Router({
    routes: [
        {
            path: '/',
            name: 'Login',
            component: Login
        },
        {
            path: '/pay',
            name: 'Pay',
            component: Pay
        },
        {
            path: '/order',
            name: 'OrderList',
            component: OrderList
        }
    ],
    mode: "history"
})